<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="showChannelListModal = true"
        >
          店铺授权
        </el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="showCreateShopModal = true"
        >
          创建店铺
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      width="500px"
      title="绑定申报参数"
      :visible.sync="showDeclareParamsModal"
      :close-on-click-modal="false"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        label-width="80px"
        ref="form"
        :model="declareParams"
      >
        <el-form-item label="货主id">
          <el-select
            filterable
            v-model="declareParams.customerId"
            placeholder="请选择货主"
          >
            <el-option
              v-for="item in getCustomerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电商企业">
          <el-select
            filterable
            style="width: 260px"
            v-model="declareParams.ebcCode"
            placeholder="请选择电商企业"
          >
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报企业">
          <el-select
            filterable
            style="width: 260px"
            v-model="declareParams.declareCode"
            placeholder="请选择申报企业"
          >
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            v-on:click="saveDeclareParams"
            style="float: right"
            type="primary"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="创建店铺"
      :visible.sync="showCreateShopModal"
      width="400px"
    >
      <el-form :rules="shopCreateRules" ref="form" :model="shopForm">
        <el-form-item prop="shopType">
          <el-select
            filterable
            style="width: 100%"
            v-model="shopForm.shopType"
            placeholder="请选择平台"
          >
            <el-option
              v-for="key in Object.keys(channelCreateType)"
              :key="key"
              :label="channelCreateType[key].name"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="shopForm.shopName"></el-input>
        </el-form-item>
        <el-form-item label="店铺编码" prop="shopCode">
          <el-input v-model="shopForm.shopCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            @click="handleCreateShop"
            style="float: right"
            type="primary"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="授权平台"
      :visible.sync="showChannelListModal"
      width="400px"
    >
      <el-form>
        <el-form-item>
          <el-select
            filterable
            style="width: 100%"
            v-model="authKey"
            placeholder="请选择授权平台"
          >
            <el-option
              v-for="key in Object.keys(authChannelList)"
              :key="key"
              :label="authChannelList[key].name"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            v-on:click="toAuth"
            style="float: right"
            type="primary"
            >确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import {mapActions, mapGetters} from "vuex";
import shopAuthApi from "@/api/shopAuthApi";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      showChannelListModal: false,
      showDeclareParamsModal: false,
      showCreateShopModal: false,
      shopForm: {
        shopType: "",
        shopName: "",
        shopCode: "",
      },
      shopCreateRules: {
        shopType: [
          { required: true, message: "请选择平台类型", trigger: "blur" },
        ],
        shopName: [
          { required: true, message: "请输入店铺名称", trigger: "blur" },
        ],
        shopCode: [
          { required: true, message: "请输入店铺编码", trigger: "blur" },
        ],
      },
      declareParams: {
        customerId: "",
        ebcCode: "",
        declareCode: "",
      },
      currentMerchant: null,
      authChannelList: {
        PINDUODUO: {
          name: "拼多多",
          path: this.$setting.PDDAUTH || "",
        },
        JD: {
          name: "京东",
          path: this.$setting.JDAUTH || "",
        },
        MEITUAN: {
          name: "美团",
          path: this.$setting.MEITUANAUTH || "",
        },
        DEWU: {
          name: "得物",
          path: this.$setting.DEWUAUTH || "",
        }
      },
      channelCreateType: {
        DOUYIN: {
          name: "抖音",
        },
        HIPAC: {
          name: "海拍客",
        },
      },
      authKey: "PINDUODUO",
      shopTypeMap: {
        PINDUODUO: "拼多多",
        MEITUAN: "美团",
        YANGCONG: "洋葱",
        DOUYIN: "抖音",
        HIPAC: "海拍客",
        JD: "京东",
        DEWU: "得物",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "店铺名称",
          width: 200,
          key: "shopName",
          align: "center",
        },
        {
          title: "店铺类型",
          width: 200,
          key: "shopType",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return <div>{this.shopTypeMap[row.shopType]}</div>;
          },
        },
        {
          title: "店铺编号",
          width: 200,
          key: "shopCode",
          align: "center",
        },
        {
          title: "货主id",
          width: 100,
          key: "customerId",
          align: "center",
        },
        {
          title: "电商企业",
          width: 200,
          key: "ebcCode",
          align: "center",
        },
        {
          title: "申报企业",
          width: 200,
          key: "declareCode",
          align: "center",
        },
        {
          title: "授权时间",
          width: 200,
          key: "authorizedAt",
          align: "center",
        },
        {
          title: "过期时间",
          width: 180,
          key: "expireAt",
          align: "center",
        },
        {
          title: "授权状态",
          width: 180,
          key: "authorizeStatus",
          align: "center",
          render(h, { row }) {
            const tagType = row.authorizeStatus ? "success" : "info";
            const tagText = row.authorizeStatus ? "已授权" : "未授权";
            return (
              <el-tag size="mini" type={tagType}>
                {tagText}
              </el-tag>
            );
          },
        },
        {
          title: "店铺状态",
          width: 180,
          key: "status",
          align: "center",
          render(h, { row }) {
            const tagType = row.status ? "success" : "info";
            const tagText = row.status ? "启用" : "禁用";
            return (
              <el-tag size="mini" type={tagType}>
                {tagText}
              </el-tag>
            );
          },
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [
              <a
                type="text"
                style={{
                  color: data.status ? "red" : "blue",
                }}
                onClick={this.updateShopStatus.bind(this, data)}
              >
                {data.status ? "禁用" : "启用"}
              </a>,
              <a
                type="text"
                style="color:blue;margin-left:10px"
                onClick={this.bindDeclareParams.bind(this, data)}
              >
                绑定申报参数
              </a>,
              <a
                type="text"
                style="color:red;margin-left:10px"
                onClick={this.handleDelele.bind(this, data)}
              >
                删除
              </a>,
            ];
            return operation;
          },
        },
      ],
      filterObj: {
        channelName: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getEnterprise: "getEnterprise",
      getCustomerList: "getCustomerList",
    }),
    shopAuthorizeData() {
      return this.$store.state.shopAuthStore.shopAuthData;
    },
  },
  methods: {
    ...mapActions("shopAuthStore", {
      list: "list",
      updateStatus: "updateStatus",
      delelte: "shopAuthorizeDelele",
    }),
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };
      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    handleCreateShop() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          shopAuthApi
            .create({
              request: {
                ...this.shopForm,
              },
            })
            .then((res) => {
              if (res.value) {
                this.$message.success("创建成功");
                this.shopForm = {};
                this.showCreateShopModal = false;
                this.fetch();
              }
            });
        }
      });
    },
    bindDeclareParams(row) {
      this.showDeclareParamsModal = true;
      this.declareParams = {
        shopId: row.id,
        customerId: row.customerId,
        ebcCode: row.ebcCode,
        declareCode: row.declareCode,
      };
    },
    saveDeclareParams() {
      shopAuthApi
        .bindDeclareParams({
          request: {
            shopId: this.declareParams.shopId,
            customerId: this.declareParams.customerId,
            ebcCode: this.declareParams.ebcCode,
            declareCode: this.declareParams.declareCode,
          },
        })
        .then((res) => {
          this.showDeclareParamsModal = false;
          if (res.value) {
            this.$message.success("绑定成功");
            this.fetch();
          }
        });
    },
    handleDelele(data) {
      this.$confirm("确认删除该店铺信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.delelte({ shopId: data.id }).then((res) => {
          if (res.value) {
            this.fetch();
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        });
      });
    },
    updateShopStatus(data) {
      this.$confirm(
        `确定更改店铺状态为${data.status ? "禁用" : "启用"}`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const params = {
          shopId: data.id,
          status: data.status ? 0 : 1,
        };
        this.comfirmUpdateShopStatus(params);
      });
    },
    comfirmUpdateShopStatus(data) {
      this.updateStatus(data).then((res) => {
        if (res.value) {
          this.fetch();
          this.$message.success("店铺状态更改成功");
        } else {
          this.$message.error("店铺状态更改失败");
        }
      });
    },
    toAuth() {
      if (!this.authKey) {
        this.$message.error("请选择授权平台");
        return;
      }
      const currentChannel = this.authChannelList[this.authKey];
      window.open(currentChannel.path, "_target");
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "店铺编号",
              model: "shopCode",
              type: type.INPUT,
            },
            {
              label: "店铺名称",
              model: "shopName",
              type: type.INPUT,
            },
            {
              label: "店铺类型",
              model: "shopType",
              type: type.SELECT,
              props: {
                data: [
                  { label: "全部", value: "" },
                  { label: "拼多多", value: "PINDUODUO" },
                  { label: "美团", value: "MEITUAN" },
                  { label: "抖音", value: "DOUYIN" },
                  { label: "洋葱", value: "YANGCONG" },
                  { label: "京东", value: "JD" },
                  { label: "得物", value: "DEWU" },
                ],
              },
            },
          ],
        },
      ];
    },
  },
  watch: {
    shopAuthorizeData(res) {
      this.dataList = res.items || [];
      const pageInfo = res.pageInfo || { totalCount: 0 };
      this.pagination.totalCount = pageInfo.totalCount;
    },
  },
};
</script>
